<!--
  画面名： -
  画面概要：食材登録フォームのコンポーネント
  備考：FoodRegistrationFormModal.vueもほとんど内容なので、このファイルを修正時は確認して下さい。
-->

<template lang="html">
  <v-form
    v-model="valid"
    ref="foodForm"
    lazy-validation
    v-if="isEditFood || isAddFood"
  >
    <!-- セレクトボックスから選択された項目を表示 -->
    <v-layout v-if="isTemplate">
      <p>{{$language.MsgTemplateCaution}}</p>
      <v-spacer />
      <!-- 編集した雛形の食材を元に戻す -->
      <v-btn
        v-if="isDefaultBtn"
        class="btn"
        small
        @click="clickRevert"
      >
        {{$language.MsgToDefault}}
      </v-btn>
      <!-- 雛形の食材を元に食材データを新規作成する -->
      <v-btn
        class="btn"
        small
        @click="clickCopyFood"
      >
        {{$language.LabelCopyCreate}}
      </v-btn>
    </v-layout>
    <div class="registerArea">
      <!-- 名称 -->
      <v-layout>
        <v-flex class="sm6">
          <v-text-field
          v-model="menu"
          :placeholder="$language.LabelName"
          :rules="[menuRules]"
          :disabled="isTemplate"
          />
        </v-flex>
        <!-- 種別 -->
        <v-flex class="sm3">
          <v-select
            v-model="type"
            :placeholder="$language.LabelType"
            :items="types"
            item-value="id"
            item-text="text"
            class="ml-2"
            :rules="[typeRules]"
            :disabled="isTemplate"
          />
        </v-flex>
        <!-- カテゴリー -->
        <v-flex class="sm3" @click="alertCategory()">
          <v-select
            :disabled="type < 0 || isTemplate"
            v-model="category"
            :placeholder="$language.LabelCategory"
            :items="categoryLists[type]"
            item-value="id"
            item-text="text"
            class="ml-2 categorySelect"
            :rules="[categoryRules]"
          />
        </v-flex>
      </v-layout>
      <!-- 食材グループ設定用リストボックス -->
      <v-flex class="xs12 sm7">
        <v-select
          placeholder="グループ"
          v-model="foodGroup"
          :items="groups"
          item-value="id"
          item-text="text"
          :rules="[groupRules]"
        />
      </v-flex>
      <!-- 工程と管理方法を表示するエリア -->
      <section style="margin-top: 10px !important;" class="process mt-4" v-if="type === 0 || (type === 1 && cookingMaterial.length === 0)">
        <h3 style="padding-bottom: 4px;">{{$language.LabelProcess}}</h3>
        <table>
          <tbody>
            <tr>
              <td
                v-for="(process, index) in processes"
                :key="index"
              >
                <v-checkbox v-model="processChecks" :value="process.id" :label="process.name"></v-checkbox>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <!-- 原材料追加（種別：料理の時） -->
      <section class="ingredientsArea mt-3"  v-if="type === 1 || type === 2">
        <div class="ingradientsTable">
          <!-- 登録された原材料を表示 -->
          <table ref="ingredients">
            <tbody id="food-table">
              <tr>
                <th style="min-width:200px;">{{$language.LabelRawMaterial}}</th>
                <th>{{$language.LabelGroup}}</th>
                <th style="min-width:120px;">{{$language.LabelAmount}}</th>
                <!-- 工程名をfor文で表示 -->
                <th v-for="(process, index) in processes" :key="index">{{process.name}}</th>
                <th colspan="1" class="border-left"></th>
              </tr>
              <!-- 追加された複合原材料を表示する -->
              <tr v-for="(element,index) in cookingMaterial" :key="`second-${index}`">
                <td>{{element.food}}</td>
                <td>{{element.groupName}}</td>
                <td>
                  <!-- 使用量 -->
                  <v-text-field
                    label="使用量を入力"
                    single-line
                    v-model="element.amount"
                    hide-details
                    style="width:110px;font-size:14px;"
                    class="pt-0"
                  />
                </td>
                <td v-for="(process, index) in processes" :key="index">
                  <span v-if="element[process.valueName]">●</span>
                  <span v-else>-</span>
                </td>
                <!-- 削除ボタン -->
                <td class="border-left">
                  <v-btn class="icon-btn" fab small color="#fff" @click="remove(index)">
                    <v-icon color="#1f4e9c">remove</v-icon>
                  </v-btn>
                </td>
              </tr>
              <!-- 食材を追加するための行 -->
              <tr class="addFoodLine">
                <td>
                  <!-- 食材追加ボタン -->
                  <v-btn
                    small
                    class="btn"
                    @click="openFoodDialog()"
                  >{{$language.LabelAdd}}
                  </v-btn>
                </td>
                <!-- ヘッダーに合わせてtdタグを追加 -->
                <td v-for="index in 14" :key="index" :class="{'no-border':index===14}"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <!-- アレルゲンを表示するエリア -->
      <Allergen
        @allergenAlert='allergenAlert'
        class="mt-4"
        :isCooking="type === 2 || (type === 1 && cookingMaterial.length !== 0)"
        :allergenchecked="allergenChecks"
        @send="openParentDialog"
        ref="refAllergen"
      />
    </div>
    <!-- 確認ダイアログ -->
    <ConfirmDialog :msg="strConfirmmsg" :isYes="true" ref="confirmDialog" />
    <!-- 料理に食材を追加するためのダイアログ -->
    <FoodDialog
      ref="FoodDialog"
      :isPlan="isPlan"
      :isDialog="true"
      :cookingMaterial="cookingMaterial"
      @getSelectedData="getSelectedData"
    />
  </v-form>
</template>

<script>
// アレルゲン
import Allergen from '@/components/parts/common/Allergen'
// 確認用モーダル
import ConfirmDialog from '@/components/parts/common/ConfirmDialog'
// 食材用定義ファイル
import DefFood from '@/config/common/foodData.json'
// ダイアログ表示用コンポーネント読込
import FoodDialog from '@/components/parts/common/FoodDialog'

export default {
  name: 'FoodRegistrationForm',
  // 親ページのデータを取得
  props: {
    // 編集かどうか判定
    isEditFood: { type: Boolean, default: false },
    // 追加かどうか判定
    isAddFood: { type: Boolean, default: false },
    // 編集する食材データを格納
    editItemData: { type: Object, default: function () { return {} } },
    // 計画策定からの判定
    isPlan: { type: Boolean, default: false }
  },
  // 子（外部）コンポーネント設定
  components: {
    // アレルゲン
    Allergen,
    // 確認ダイアログ
    ConfirmDialog,
    // 食材ダイアログ
    FoodDialog
  },
  // コンポーネント内の変数を定義
  data () {
    return {
      // 名称
      menu: '',
      // 初期表示する食材グループ
      foodGroup: -1,
      // 食材グループ一覧
      groups: [],
      // 原材料
      materialInfo: [],
      // 種別
      type: -1,
      // 定義ファイルを格納する
      defFood: [],
      // 種別一覧
      types: [],
      // チェックされたアレルゲンを文字列で格納
      allergenChecks: '',
      // カテゴリ
      category: '',
      // カテゴリリスト
      categoryLists: [],
      // プロセス
      processes: [],
      // チェックされた作業工程を格納する配列
      processChecks: [],
      // バリデーションのチェックフラグ
      valid: true,
      // 一回目のwatchを通らないようにする
      isWatch: true,
      // 雛形の食材か判定する
      isTemplate: false,
      // 雛形食材データを格納する
      arrTemplateFoodData: [],
      // デフォルトに戻すボタンが押下されたかどうかを判定するフラグ
      isRevert: false,
      // 事業社DBに登録する雛形食材IDの初期値
      baseId: -1,
      // デフォルトに戻すボタンの表示判定
      isDefaultBtn: false,
      // 料理に含まれる食材
      cookingMaterial: [],
      // 確認ダイアログに表示するメッセージ
      strConfirmmsg: '',
      watchCount: 0
    }
  },
  // 画面表示時に実行する関数を設定
  created () {
    // 食材の定義ファイルを設定
    this.defFood = DefFood.Food
    // 食材種別リストを取得する
    this.getTypeList()
    // 編集ボタンから遷移してきた場合の処理
    if (this.isEditFood) {
      // 食材データを取得
      this.getFoodData()
    } else {
      this.isTemplate = false
    }
    this.watch = false
  },
  // Vueインスタンスを監視
  watch: {
    // 食材グループを監視
    foodGroup () {
      if (!(this.isEditFood && this.watchCount === 0)) {
        this.setProcessByfoodGroup()
      }
      this.watchCount++
    },
    // 種別の変更を監視
    type () {
      if (this.type === 2) {
        // 料理が選択されたらアレルゲンを再設定

        this.connectInsertAllergen(this.cookingMaterial)
      } else if (this.type === 1 && this.cookingMaterial.length !== 0) {
        // 仕込み品が選択され、かつ原材料が選択されている場合は、原材料のアレルゲンを反映

        this.connectInsertAllergen(this.cookingMaterial)
      }
    }
  },
  // 関数群
  methods: {
    // アレルゲンのリストボックスをクリックした時に発火する処理
    allergenAlert () {
      this.strConfirmmsg = this.$language.MsgAllergenAuto
      // アレルゲンを再設定
      this.connectInsertAllergen(this.cookingMaterial)
      // 食材登録ページに遷移するか確認するダイアログを表示する
      this.$refs.confirmDialog.openDialog()
    },
    // 食材ダイアログを表示する
    openFoodDialog () {
      this.$refs.FoodDialog.showDialog()
    },
    // 子コンポーネントから取得。選択された食材を料理の原材料に追加
    getSelectedData (value) {
      this.cookingMaterial = this.cookingMaterial.concat(value)
      this.connectInsertAllergen(this.cookingMaterial)
    },
    // 食材削除処理
    remove (i) {
      this.cookingMaterial.splice(i, 1)
      this.connectInsertAllergen(this.cookingMaterial)
    },
    connectInsertAllergen (AcookingMaterial) {
      let allergenList = ''
      AcookingMaterial.forEach(function (value) {
        if (value.allergen) {
          allergenList = allergenList + value.allergen + ','
        }
      })
      allergenList = allergenList.slice(0, -1)
      // 子コンポーネントのアレルゲンを再挿入する（原材料に含まれるアレルゲンを追加）
      this.$refs.refAllergen.reinsertAllergen(allergenList)
    },
    // 種別を選択する前にカテゴリをクリックした際はアラートを表示する
    alertCategory () {
      this.strConfirmmsg = this.$language.MsgSelectedType
      if (this.type < 0) {
        // 種別を選択して下さい、のアラートを表示する
        this.openConfirmDialog()
      }
    },
    // 確認用ダイアログを表示
    openConfirmDialog () {
      this.$refs.confirmDialog.openDialog()
    },
    // 編集した雛形食材をデフォルトに戻す
    clickRevert () {
      if (this.foodGroup === this.arrTemplateFoodData[0].group) {
        this.isRevert = false
      } else {
        this.isRevert = true
      }
      // 雛形IDから雛形の食材データを取得してデータを入れ直す
      this.foodGroup = this.arrTemplateFoodData[0].group
      this.$nextTick(function () {
        this.$refs.refAllergen.setDefaultAllergen(this.arrTemplateFoodData[0].allergen)
        this.processChecks = this.arrTemplateFoodData[0].process
        this.$forceUpdate()
      })
    },
    // コピーして作成
    clickCopyFood () {
      // 現在のデータから新規作成する
      this.isTemplate = false
      this.$emit('changeFlag2Add')
    },
    // コピーして作成された際に発火。baseIdを-1に設定する
    changeBaseId () {
      this.baseId = -1
    },
    // 食材グループに対応する工程を設定する
    setProcessByfoodGroup () {
      let f = this.defFood
      if (this.foodGroup === f.Normal) {
        // グループ0：加熱殺菌や冷却せず、常温のまま提供するもの
        this.processChecks = [f.Reception, f.RawMaterialStorage, f.Dishing, f.Offer]
      } else if (this.foodGroup === f.Unheated) {
        // グループ1：加熱殺菌せず、冷たいまま提供するもの
        this.processChecks = [f.Reception, f.RawMaterialStorage, f.Dishing, f.Offer]
      } else if (this.foodGroup === f.HeatRefrigerated) {
        // グループ2：加熱殺菌し、熱いまま提供するもの
        this.processChecks = [f.Reception, f.RawMaterialStorage, f.HeatSterilization, f.Dishing, f.Offer]
      } else if (this.foodGroup === f.AllHeating) {
        // グループ2：加熱殺菌後に高温保管した後、熱いまま提供するもの
        this.processChecks = [f.Reception, f.RawMaterialStorage, f.HeatSterilization, f.HighTemperatureStorage, f.Dishing, f.Offer]
      } else if (this.foodGroup === f.CoolAfterHeat) {
        // グループ3：加熱殺菌後冷却して、冷たいまま提供するもの
        this.processChecks = [f.Reception, f.RawMaterialStorage, f.HeatSterilization, f.Cooling, f.Dishing, f.Offer]
      } else if (this.foodGroup === f.ReHeating) {
        // グループ3：加熱殺菌後冷却して、再加熱し、熱いまま提供するもの
        this.processChecks = [f.Reception, f.RawMaterialStorage, f.HeatSterilization, f.Cooling, f.Reheating, f.Dishing, f.Offer]
      } else {
        // グループなし
        this.processChecks = [f.Reception, f.RawMaterialStorage]
      }
    },
    // 親コンポーネントから送られたデータを格納登録されているレシピのデータを取得
    getFoodData () {
      this.menu = this.editItemData.food
      this.type = this.editItemData.type
      this.category = this.editItemData.category
      this.foodGroup = this.editItemData.group
      this.processChecks = this.editItemData.process
      this.baseId = this.editItemData.baseId
      this.allergenChecks = this.editItemData.allergen
      this.cookingMaterial = this.editItemData.cookingMaterial

      // 雛形からコピーしてきた食材の場合
      if (this.baseId > 0) {
        this.isTemplate = true
        // 雛形から該当の食材を取得する
        this.getTemplateFood(this.baseId)
      }
    },
    /**
     * DB操作
     */
    // 食材の種別リストを取得する
    getTypeList () {
      let self = this
      // 食材種別リスト取得のコールバック処理
      function callbackGetTypeList (response) {
        // データベースから取得した食材の種別リストを格納
        self.types = response
        self.$forceUpdate()
        // 食材カテゴリのjsonデータを取得する
        self.getCategoryJson()
      }
      let data = {}
      data.callback = callbackGetTypeList
      this.$store.dispatch('types/actionSelectTypes', data)
    },
    // カテゴリのjsonデータを取得する
    getCategoryJson () {
      let self = this
      // カテゴリー一覧を取得した後のコールバック処理
      function callbackGetCategoryJson (response) {
        // データベースから取得したアレルゲン一覧を格納
        self.categoryLists = response
        self.$forceUpdate()
        self.getFoodGroup()
      }
      let data = {}
      data.callback = callbackGetCategoryJson
      this.$store.dispatch('foodCategory/actionSelectFoodCategory', data)
    },
    // 食材グループを格納
    getFoodGroup () {
      let self = this
      function callbackGetFoodGroup (response) {
        // データベースから取得した食材グループを格納
        self.groups = response
        self.$forceUpdate()
        // 食材グループをDBから取得
        self.getProcess()
      }
      let data = {}
      data.callback = callbackGetFoodGroup
      this.$store.dispatch('foodGroups/actionSelectFoodGroups', data)
    },
    // 工程を取得
    getProcess () {
      let self = this
      function callbackGetProcess (response) {
        // データベースから取得した工程一覧を格納
        self.processes = response
        self.$forceUpdate()
        self.$refs.refAllergen.makeAllergenFrame()
      }
      let data = {}
      data.callback = callbackGetProcess
      this.$store.dispatch('processes/actionSelectProcesses', data)
    },
    // 親コンポーネントのダイアログ表示
    openParentDialog () {
      this.$emit('showDialog')
    },
    // 雛形の元のデータを格納する処理（デフォルトに戻すボタンが発火されたときに使用するデータ）
    getTemplateFood (intBaseId) {
      this.arrTemplateFoodData = []
      let self = this
      function callbackGetTemplateFood (response) {
        // 雛形の食材が削除されていないかチェックする
        if (response.length > 0) {
          setTemplateFood(response)
          self.$forceUpdate()
          self.isDefaultBtn = true
        }
      }
      let data = {}
      data.id = intBaseId
      data.callback = callbackGetTemplateFood
      this.$store.dispatch('systemConfig/actionSelectFoodDataById', data)
      // DBから取得した食材（原材料）一覧を格納
      function setTemplateFood (data) {
        let arrProcess = data[0].process.split(',').map(Number)
        self.arrTemplateFoodData.push({
          group: data[0].food_group_code,
          allergen: data[0].allergen,
          process: arrProcess
        })
      }
    },

    /**
     * バリデーションルールを設定
     */
    // 名称バリデーション設定
    menuRules () {
      // メニュー名バリデーション
      if (this.menu) {
        return true
      } else {
        return this.$language.MsgNecessary
      }
    },
    // 種別のバリデーション設定
    typeRules () {
      if (this.type >= 0) {
        return true
      } else {
        return this.$language.MsgNecessary
      }
    },
    // カテゴリバリデーション設定
    categoryRules () {
      if (this.type === this.defFood.RawMaterial) {
        if (this.category >= 100 && this.category <= 199) {
          return true
        }
      } else if (this.type === this.defFood.Preparation) {
        if (this.category >= 200 && this.category <= 299) {
          return true
        }
      } else if (this.type === this.defFood.Cooking) {
        if (this.category >= 300 && this.category <= 399) {
          return true
        }
      }
      // 「必須項目です」のメッセージを返す
      return this.$language.MsgNecessary
    },
    // 食材グループのバリデーション
    groupRules () {
      if (this.foodGroup >= 0) {
        return true
      } else {
        return this.$language.MsgNecessary
      }
    },
    // バリデーション
    validate () {
      if (this.$refs.foodForm.validate()) {
        // 料理に含まれる食材データを文字列化
        let strCookingMaterial = ''
        // 仕込み品と料理の場合
        if ((this.type === 1 || this.type === 2) && this.cookingMaterial.length > 0) {
          strCookingMaterial = JSON.stringify(this.cookingMaterial)
        }

        if (this.type === this.defFood.Cooking) {
          // 料理の場合は工程をクリアする

          this.processChecks = []
        } else if (this.type === this.defFood.Preparation && strCookingMaterial !== '') {
          // 仕込み品でかつ原材料を引用している場合は原材料の工程を合算する

          let arrProcesses = []
          for (let i = 0; i < this.cookingMaterial.length; i++) {
            // 配列を結合
            arrProcesses = arrProcesses.concat(this.cookingMaterial[i].process)
          }
          // 重複を削除して工程を設定
          this.processChecks = Array.from(new Set(arrProcesses))
        }

        // 管理機能の雛形の食材を編集した場合
        if (this.isTemplate) {
          if (this.editItemData.itemId > 0) {
            // 事業者の食材テーブルに追加済みの食材を編集
            this.$emit(
              'templateFoodUpdate',
              {
                id: this.editItemData.itemId,
                food: this.menu,
                type: this.type,
                category: this.category,
                group: this.foodGroup,
                allergen: this.$refs.refAllergen.allergenChecks.join(','),
                cookingMaterial: strCookingMaterial,
                process: this.processChecks.join(',')
              }
            )
          } else {
            // 雛形の食材を事業者の食材テーブルに新規追加
            this.$emit(
              'templateFoodInsert',
              {
                food: this.menu,
                type: this.type,
                category: this.category,
                group: this.foodGroup,
                allergen: this.$refs.refAllergen.allergenChecks.join(','),
                process: this.processChecks.join(','),
                cookingMaterial: strCookingMaterial,
                baseId: this.baseId
              }
            )
          }
        } else if (this.isAddFood) {
          // 食材新規追加の場合
          this.$emit(
            'confirm',
            {
              food: this.menu,
              type: this.type,
              category: this.category,
              group: this.foodGroup,
              allergen: this.$refs.refAllergen.allergenChecks.join(','),
              process: this.processChecks.join(','),
              cookingMaterial: strCookingMaterial,
              baseId: this.baseId
            }
          )
        } else if (this.isEditFood) {
          // 食材を編集する場合
          this.$emit(
            'confirm',
            {
              id: this.editItemData.itemId,
              food: this.menu,
              type: this.type,
              category: this.category,
              group: this.foodGroup,
              allergen: this.$refs.refAllergen.allergenChecks.join(','),
              cookingMaterial: strCookingMaterial,
              process: this.processChecks.join(',')
            }
          )
        }
      }
    }
  }
}
</script>

<!-- style読み込み -->
<style lang="scss" scoped>
  @import '@/assets/scss/common/foodData.scss';
</style>
